<div class="container steps">
    <h1 [innerHTML]="'booking.steps.headline' | translate"></h1>
    <div class="steps-wrapper">
        <div class="first step" [class.active]="isActive(1)" [class.current]="isCurrent(1)">
            <span class="circle"
                ><span class="content"><em>1</em><em [innerHTML]="'booking.steps.first' | translate"></em></span
            ></span>
        </div>
        <div class="second step" [class.active]="isActive(2)" [class.current]="isCurrent(2)">
            <span class="line"></span
            ><span class="circle"
                ><span class="content"><em>2</em><em [innerHTML]="'booking.steps.second' | translate"></em></span
            ></span>
        </div>
        <div class="third step" [class.active]="isActive(3)" [class.current]="isCurrent(3)">
            <span class="line"></span
            ><span class="circle"
                ><span class="content"><em>3</em><em [innerHTML]="'booking.steps.third' | translate"></em></span
            ></span>
        </div>
        <div class="fourth step" [class.active]="isActive(4)" [class.current]="isCurrent(4)">
            <span class="line"></span
            ><span class="circle"
                ><span class="content"><em>4</em><em [innerHTML]="'booking.steps.fourth' | translate"></em></span
            ></span>
        </div>
    </div>
</div>
